<template>
    <div class="nav">
      <div>
          <el-image class="logo" :src="require(`@/assets/logo2.png`)"></el-image>
      </div>
      <el-row>
        <el-col :xs="0" :sm="24" :md="24" :lg="24" :xl="24">
          <div style="display:flex;align-items:center;">
            <el-menu :router="true" :default-active="activeIndex" active-text-color="#333333" background-color="#ffffff" class="el-menu-demo" mode="horizontal" @select="handleSelect">
            <el-menu-item index="/">首页</el-menu-item>
            <el-menu-item v-for="item,index in list" :key="index" :index="item.etitle">{{ item.title }}</el-menu-item>
            </el-menu>
            <div class="lianxi">
              <el-image
                class="hone"
                :src="require('@/assets/hone2.png')"></el-image>
                <div class="dianhau">0371-55886162</div>
            </div>

          </div>
        </el-col>
        <el-col :xs="24" :sm="0" :md="0" :lg="0" :xl="0">
          <i  @click="isShow = !isShow" :class="isShow? 'el-icon-close':'el-icon-s-grid' "></i>
        </el-col>
      </el-row>


      <diaLog :isShow="isShow" @updateVisible="updateVisible"/>
    </div>
</template>
<script>
import {mapState} from 'vuex'
import diaLog from '@/components/diaLog.vue'
import StudentsApi from "@/apis/service.js";
export default{
    components:{
        diaLog
    },
    data(){
        return{
          isShow: false,
          activeIndex: '1',
          textcolor:'#ffffff',
          list:[],
      
        }
    },
    metaInfo() {
        return {
          title: this.meta.title,
          meta: [
            { name: "keywords", content: this.meta.keywords },
            { name: "description", content: this.meta.description },
          ],
        };
    },
    computed: {
      ...mapState(['meta'])
    },
    async mounted() {
      this.list = await StudentsApi.tagNav();
      this.$store.commit('sertagNav', this.list)
    },
    methods:{
      updateVisible(val){
          console.log(val,'val');
          this.isShow = val
      },
      handleClose(done) {
        done();
        // this.$confirm('确认关闭？')
        //   .then(_ => {
        //     done();
        //   })
        //   .catch(_ => {});
      },
      handleSelect(e){
          if (e == '/') {
            // this.color = '#016F62'
            // this.textcolor= '#ffffff'
            // this.activetextcolor = '#333333'
          }else{
            // this.color = '#ffffff'
            // this.textcolor= '#000000'
            // this.activetextcolor = '#ffffff'
          }
          

      }
    }
}


</script>
<style scoped lang="less">
::v-deep .el-menu-item{
  display: flex;
  align-items: center;
  justify-content: center;
}
.el-icon-s-fold{
  color: #333333;
}
.nav{
  padding: 0 120px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 140px;
}

 .logo{
    width: 200px;
    height: 108px;
    
  }
  @media screen and (max-width: 749px) {
  .nav {
      height: 50px;
     
    }
    .logo{
      width: 100px;
      height: 40px;
      margin-top: 5px;
  }
  i{
    font-size: 28px;
  }
}
  .lianxi{
    display: flex;
    align-items: center;
    .hone{
    width: 37px;
    height: 37px;
   
    margin: 0 20px ;
    }
    .dianhau{
      // margin-left: 10px;
      height: 50px;
      width: 200px;
      background-color: #FFD55F;
      font-size: 18px;
      border-radius: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: white;
    }
  }
  
  .el-menu.el-menu--horizontal {
    border-bottom:none;
  }
  .el-menu-demo .el-menu-item{
    font-size: 16px;
  }

</style>